import { useTranslation } from "react-i18next";

import { showDeleteAlert } from "@components/molecules/alert";
import { useNotifyPromise } from "@hooks";
import { useDeclineAppointment } from "@api/appointment";
import type { ID } from "@constants";

export const useDeclineAppointmentFunc = (id: ID) => {
  const { t } = useTranslation("form");

  const notifyMutate = useNotifyPromise();
  const { mutateAsync } = useDeclineAppointment();

  return () =>
    showDeleteAlert({
      title: t("decline_appointment"),
      content: t("decline_appointment_text"),
      onApprove: async () => {
        await notifyMutate(mutateAsync({ appointmentId: id }));
      },
      approveTitle: t("decline_appointment"),
    });
};
